import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import { getCurrentUser } from 'utils/localStorage';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  const currentUser = getCurrentUser();
  switch (type) {
    case types.GET_CART_REQUEST_SUCCESS:
      const templates = { ...payload.entities.templates };
      for (let id in templates) {
        if (templates[id].addedBy.userId === currentUser.userId) {
          templates[id].selected = true;
        } else {
          templates[id].selected = false;
        }
      }

      return templates;
    case types.GET_ADDITIONAL_CART_REQUEST_SUCCESS:
      const additionalTemplates = { ...payload.entities.templates };
      for (let id in additionalTemplates) {
        if (additionalTemplates[id].addedBy.userId === currentUser.userId) {
          additionalTemplates[id].selected = true;
        } else {
          additionalTemplates[id].selected = false;
        }
      }

      return Object.assign({}, state, additionalTemplates);
    case types.UNSELECT_TEMPLATE_IN_CART: {
      const updatedState = { ...state };
      updatedState[payload].selected = false;
      return updatedState;
    }
    case types.SELECT_TEMPLATE_IN_CART: {
      const updatedState = { ...state };
      updatedState[payload].selected = true;
      return updatedState;
    }
    case types.SELECT_ALL_TEMPLATES_CART_BODY_STYLE: {
      const updatedState = { ...state };
      const templateIds = payload.templateIds;
      templateIds.forEach(templateId => {
        updatedState[templateId].selected = true;
      });
      return updatedState;
    }
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
